import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import registration from './modules/registration'
import company from './modules/company'
import companyJobs from './modules/companyJobs'
import companyDocuments from './modules/companyDocuments'
import factoring from './modules/factoring'

Vue.use(Vuex)

const sessionStorageKeyFilterDashboard = 'filter-dashboard-by-user'

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    user,
    registration,
    company,
    companyJobs,
    companyDocuments,
    factoring
  },
  state: {
    justRegistered: false,
    activeShipperDashboardCategory: 'isInProgress',
    activeFactoringDashboardCategory: 2,
    filterDashboardByUser: window.sessionStorage.getItem(sessionStorageKeyFilterDashboard) || '',
    preSelectedShipTo: ''
  },
  mutations: {
    SET_FILTER_BY_USER(state, accountKey) {
      state.filterDashboardByUser = accountKey
      window.sessionStorage.setItem(sessionStorageKeyFilterDashboard, accountKey)
    },
    SET_REGISTRATION_FLAG(state, value = true) {
      state.justRegistered = value
    },
    SET_ACTIVE_FACTORING_DASHBOARD_CATEGORY(state, category) {
      state.activeFactoringDashboardCategory = category
    },
    SET_ACTIVE_SHIPPER_DASHBOARD_CATEGORY(state, category) {
      state.activeShipperDashboardCategory = category
    },
    SET_PRESELECTED_SHIP_TO(state, companyRolodexJobLocation) {
      state.preSelectedShipTo = companyRolodexJobLocation
    }
  },
  actions: {}
})
